import React from 'react';

import {useIconPositioningContext} from '../../state/issues/IconPositioningContext';
import {type AnnotationHoverSource} from '../vis/annotations';
import {type GraphAnnotations} from './graphRenderProps';
import {IssueAlert} from './IssueAlert';
import {buildIssueAlerts} from './issueMarkers';

/**
 * The issue arrows and markers above the plot. Marker positions come from the
 * icon-positioning context that Graph provides, so this renders inside
 * IconPositioningContextProvider.
 */
export function IssueMarkerList({
  annotations,
}: {
  annotations: GraphAnnotations;
}) {
  const {
    hasAfterIssues,
    hasBeforeIssues,
    marginLeft,
    marginRight,
    sortedPositionedIssues,
  } = useIconPositioningContext();
  const issueAlerts = buildIssueAlerts({
    annotationActive: annotations.isActive,
    xAxisMin: annotations.markerQueryXMin,
    xAxisMax: annotations.markerQueryXMax,
    hasAfterIssues,
    hasBeforeIssues,
    marginLeft,
    marginRight,
    sortedPositionedIssues,
  });
  const hoveredIssueSource: AnnotationHoverSource = {
    get: annotations.readHoveredId,
    subscribe: annotations.subscribeToHover,
  };

  return (
    <>
      {issueAlerts.map(alert => (
        <IssueAlert
          key={alert.key}
          alert={alert}
          hoveredIssueSource={hoveredIssueSource}
          onIssueHover={annotations.onHover}
          onIssueSelect={annotations.onActivate}
        />
      ))}
    </>
  );
}
